let initAuthState = {
  authenticated: null,
  anon: null,
  user: null,
  firestoreUser: null
};

export default function authReducer(state = initAuthState, action) {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        authenticated: true,
        anon: false,
        user: action.payload
      };
    case "LOGIN_ANON":
      return {
        ...state,
        authenticated: !action.payload.isAnonymous,
        anon: action.payload.isAnonymous,
        user: action.payload
      };
    case "LOGOUT":
      return {
        ...state,
        authenticated: false,
        user: null,
        firestoreUser: null
      };
    case "FIRESTORE_USER":
      return {
        ...state,
        firestoreUser: action.payload
      };
    default:
      return state;
  }
}
